import * as React from 'react';
import { STATE } from 'app/constants';
import { ShellState, AuthState } from 'app/types-shared';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { LoginProgress } from './login-progress';
import { LoginFailed } from './login-failed';
import { Logout } from './logout';

type AuthViewContainerProps = ShellState & DefaultContainerProps;

export class AuthViewComponent extends React.Component<AuthViewContainerProps, any> {
  public static statePath: string = STATE.app;

  public render() {
    if (this.props.authState === AuthState.NotAuthenticated
      || (this.props.authState === AuthState.Authenticated && !this.props.userInfo)) {
      return (<LoginProgress />);
    }

    if (this.props.authState === AuthState.LoggedOut) {
      return (<Logout />);
    }

    if (this.props.authState === AuthState.AuthenticationFailed) {
      return (<LoginFailed />);
    }

    return null;
  }
}

const container = containerFactory(AuthViewComponent, null);
export { container as AuthView };
